const intersectionObserverCallback = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
  entries.forEach((entry) => {

    if (entry.boundingClientRect.top >= 0) {
        entry.target.classList.add("fade-up");
    } else {
      entry.target.classList.add("fade-disabled");
      observer.unobserve(entry.target);
    }

    if (entry.isIntersecting) {
      requestAnimationFrame(() => {
        entry.target.classList.add("intersecting");
      })
      observer.unobserve(entry.target);
    }

  })
}

const options: IntersectionObserverOptions = {
  root: null, // viewport
  rootMargin: "20px",
  threshold: 0 // default: 0
}

export default new IntersectionObserver(intersectionObserverCallback, options);
